import React from "react";
import { cn } from "@RHCommerceDev/utils/cn";

const RHHamburgerIconV2 = ({
  className,
  strokeWidth = 0.75,
  ...restProps
}: React.ComponentProps<"svg">) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("text-black", className)}
      {...restProps}
    >
      <line
        x1="1"
        y1="3.625"
        x2="23"
        y2="3.625"
        stroke="currentColor"
        stroke-width={strokeWidth}
      />
      <line
        x1="1"
        y1="11.625"
        x2="23"
        y2="11.625"
        stroke="currentColor"
        stroke-width={strokeWidth}
      />
      <line
        x1="1"
        y1="19.625"
        x2="23"
        y2="19.625"
        stroke="currentColor"
        stroke-width={strokeWidth}
      />
    </svg>
  );
};

export default RHHamburgerIconV2;
